import { DigiliUserInfoResponse } from '@shared/digili'
import { ErrorCode, UserInfoResponse } from '@shared/types'
import { JSX } from 'react'

import { TransitionErrorIndicatorProps } from '../../components/TransitionErrorIndicator'
import { GetDataStep } from '../GetDataStep/GetDataStep'

export interface GetUserInfoStepProps<TUser extends UserInfoResponse | DigiliUserInfoResponse> {
  onAbort: () => unknown
  onGetUserInfoDone: (data: TUser) => void
  getUserInfo: () => Promise<TUser>
  getErrorProperties?: (errorCode?: ErrorCode, requestId?: string) => TransitionErrorIndicatorProps | undefined
  testId?: string
}

export const GetUserInfoStep = <TUser extends UserInfoResponse | DigiliUserInfoResponse>({
  onAbort,
  onGetUserInfoDone: proceed,
  getUserInfo,
  getErrorProperties,
  testId,
}: GetUserInfoStepProps<TUser>): JSX.Element => {
  return (
    <GetDataStep<TUser>
      callbacks={{ proceed }}
      getDataCallback={getUserInfo}
      onAbort={onAbort}
      testId={testId ?? 'get-user-info'}
      getErrorProperties={getErrorProperties}
    />
  )
}

export default GetUserInfoStep
